import GeneralHeader from "src/components/Sections/General/GeneralHeader/GeneralHeader";
import Certificates from "src/components/Sections/AboutCompany/Certificates/Certificates";
import AboutUs from "src/components/Sections/AboutCompany/AboutUs/AboutUs";
import Production from "src/components/Sections/AboutCompany/Production/Production";
import TestStation from "src/components/Sections/AboutCompany/TestStation/TestStation";
import OurTeam from "src/components/Sections/AboutCompany/OurTeam/OurTeam";

const AboutCompany = () => (
    <>
      <GeneralHeader />
      <AboutUs />
      <Production />
      <Certificates />
      <TestStation />
      <OurTeam />
    </>
  );

export default AboutCompany;